import { toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0653963e")

_pushScopeId("data-v-0653963e")
const _hoisted_1 = { class: "recommend-title-area" }
const _hoisted_2 = { class: "commonTextBodyStrong" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _withDirectives(_createVNode("div", {
      class: "commonButtonText",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickSeeMore(...args)))
    }, " もっと見る ", 512), [
      [_vShow, _ctx.seeMoreEnable]
    ]),
    _withDirectives(_createVNode("div", {
      class: "commonButtonText button-text-disable-color",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickSeeMore(...args)))
    }, " もっと見る ", 512), [
      [_vShow, !_ctx.seeMoreEnable]
    ])
  ]))
})